import api from '@/api';
import { API_BASE_URL } from '../../index';
import { FutureServicesMovementRequest } from './futureServices.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getReportFutureServicesMovement(
  params: FutureServicesMovementRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/future-services`,
    params,
  )) as unknown;

  return result as BlobPart;
}
